import React from "react";

export default function ProgressBar({ progress }) {
    return (
      <div style={{ margin: "10px 0" }}>
        <div style={{ width: "80%", margin: "0 auto", background: "#ddd", borderRadius: 10, height: 20 }}>
          <div style={{
            width: `${progress}%`,
            background: "#4caf50",
            height: 20,
            transition: "width 0.3s"
          }} />
        </div>
        <p>{progress}% complete</p>
      </div>
    );
  }
  